import type { CommerceQuoteDto } from "@zipper/customer-commerce-client";
import { fromPromise } from "xstate";
import type { CheckoutGateway, QuoteInput } from "./contracts";
import { runCheckoutActor } from "./timeout";

export interface QuoteActorInput extends QuoteInput {
  gateway: CheckoutGateway;
}

export const quoteActor = fromPromise<CommerceQuoteDto, QuoteActorInput>(
  async ({ input, signal }) =>
    runCheckoutActor(signal, (derivedSignal) =>
      input.gateway.quote({
        runtime: input.runtime,
        request: input.request,
        signal: derivedSignal,
      }),
    ),
);
